export class UserClaimDto implements IUserClaimDto {
  id?: number;
  claimType?: string | undefined;
  claimValue?: string | undefined;

  constructor(data?: IUserClaimDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.claimType = _data["claimType"];
          this.claimValue = _data["claimValue"];
      }
  }

  static fromJS(data: any): UserClaimDto {
      data = typeof data === 'object' ? data : {};
      let result = new UserClaimDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["claimType"] = this.claimType;
      data["claimValue"] = this.claimValue;
      return data;
  }
}

export interface IUserClaimDto {
  id?: number;
  claimType?: string | undefined;
  claimValue?: string | undefined;
}
